export enum FinancialReportType {
  AccountPayableSchedule = "ACCOUNTS_PAYABLE_SCHEDULE",
  AgedAccountsReceivable = "AGED_ACCOUNTS_RECEIVABLE",
  BalanceSheet = "BALANCE_SHEET",
  BankReconciliation = "BANK_RECONCILIATION",
  CashFlowStatement = "CASH_FLOW_STATEMENT",
  EmployeeExpenseSchedule = "EMPLOYEE_EXPENSE_SCHEDULE",
  FixedAssetSchedule = "FIXED_ASSET_SCHEDULE",
  GeneralLedgerDetail = "GENERAL_LEDGER_DETAIL",
  IncomeStatement = "INCOME_STATEMENT",
  LaborDistribution = "LABOR_DISTRIBUTION",
  LaborDistributionByAccount = "LABOR_DISTRIBUTION_BY_ACCOUNT",
  OperatingExpenseSchedule = "OPERATING_EXPENSE_SCHEDULE",
  RetainedEarningsStatement = "RETAINED_EARNINGS_STATEMENT",
}
